import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';

class CPTForm extends React.Component {
  constructor() {
    super();

    this.state = {
      primary: {},
    };
  }

  componentDidMount() {
    //const initialValues = this.props;
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <input
            {...input}
            className="form-control"
            placeholder={label}
            type={type}
            disabled={disabled}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );


  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      initialValues
    } = this.props;

    const isAdd = initialValues.procedure === null;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>CPT Information</legend>
          <Field
            className="form-control"
            name="procedure"
            component={this.renderField}
            type="text"
            placeholder="PROCEDURE"
            label="PROCEDURE"
            disabled={!isAdd}
          />
          <Field
            className="form-control"
            name="description"
            component={this.renderField}
            type="textarea"
            placeholder="Description"
            label="Description"
          />
          <Field
            className="form-control"
            name="mcare150"
            component={this.renderField}
            type="text"
            placeholder="MCare150"
            label="MCare150"
          />
        </fieldset>


        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.procedure) {
    errors.procedure = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  if (!values.mcare150) {
    errors.mcare150 = 'Required';
  }
  return errors;
};

CPTForm = connect(state => ({
  formValues: getFormValues('cpt')(state),
  initialValues: state.cptlookup.cpt,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'cpt' })(CPTForm));
export default CPTForm;



// WEBPACK FOOTER //
// ./src/routes/resource-library/components/CPTForm.js